import {DataObjectId, Hub} from 'yougile-model'
import {Task} from '@extensions/task'
import {COLUMN_NAMES} from '../constants'
import {ImportFromFileStore} from '../import-from-file-store'
import {Row, State} from '../types'
import {getCustomStickers} from './get-custom-stickers'
import {getStickers} from './get-stickers'
import {addToCheckProcessedColumn} from './utils/add-to-check-processed-column'
import {getRowValue} from './utils/get-row-value'
import {processArchived} from './utils/process-archived'
import {processComplete} from './utils/process-complete'
import {processCreatedDate} from './utils/process-created-date'
import {processDescription} from './utils/process-description'

type Props = {
  taskTitle: string
  state: State
  store: ImportFromFileStore
  row: Row
  columnId?: DataObjectId
  companyId?: DataObjectId
  board: Hub
}

export const createTask = (props: Props): Hub => {
  const {state, store, row, columnId, companyId, board} = props
  const taskTitle = getRowValue(state, row, COLUMN_NAMES.TITLE)
  addToCheckProcessedColumn(state, COLUMN_NAMES.TITLE)
  const task = Task.createTask(taskTitle, {
    location: columnId,
    companyId,
    noAutoSubscribe: true,
    toEnd: true,
    ...getStickers(state, row)
  })

  const processedColumns = state.processedColumns
  const taskCustomStickers = getCustomStickers(
    row,
    store,
    processedColumns,
    board
  )
  task.stickers = {...taskCustomStickers, ...task.stickers}

  processDescription(state, row, task)
  processComplete(state, row, task)
  processCreatedDate(state, row, task)
  processArchived(state, row, task)

  task.commit()
  return task
}
